import React from 'react';
const GlobalLocaleContext = React.createContext({
    globalLocale: null,
    displayLocale: null,
    localeDirection: null,
    updateGlobalLocale: () => { },
    updateDisplayLocale: () => { }
});

export default GlobalLocaleContext;
